'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ErrorCross = require('./ErrorCross');

var _ErrorCross2 = _interopRequireDefault(_ErrorCross);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorCross2.default;